import React from 'react';
import { usePeriod } from '../../../../hooks/usePeriod';
import { usePeriodReturn } from '../../../../components/PeriodReturn/usePeriodReturn';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { ValueVsInvestmentChart } from '../../../../components/ValueVsInvestmentChart/ValueVsInvestmentChart';
import { MobileAccountsList } from '../../../../components/MobileAccountsList/MobileAccountsList';
import { RelatedHouseholds } from '../../../../../ContextualSidebar/NetWorthSidebar/components/RelatedHouseholds/RelatedHouseholds';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { PerformanceSummary } from '../../../../components/PerformanceSummary/PerformanceSummary';
import { AssetAllocationChart } from '../../../../components/AssetAllocationChart/AssetAllocationChart';
import { MobileHelperText } from '../../../../components/MobileHelperText/MobileHelperText';
import { useValidatePeriod } from '../../../../hooks/useValidatePeriod';
import { usePerformanceReportingContext } from '../../../../context/usePerformanceReportingContext';
import { useRouteParams } from '../../../../hooks/useRouteParams';
import { MobilePageWrapper } from '../../../../AccountPerformanceReporting.styles';

export const SummaryMobile = () => {
  const { focusedAccountId, updatedAt, selectedItemName } = usePerformanceReportingContext();

  useValidatePeriod();

  const { label: periodLabel } = usePeriod();
  const { data: periodReturnData } = usePeriodReturn();

  const portfolioReturn = periodReturnData?.value ? parseFloat(periodReturnData?.value) : null;

  const { clientId } = useRouteParams();

  return (
    <>
      <MobilePageWrapper>
        <Box>
          <ValueVsInvestmentChart
            title={selectedItemName}
            portfolioReturn={portfolioReturn}
            updatedAt={updatedAt}
          />
        </Box>

        {!focusedAccountId && <MobileAccountsList clientId={clientId} updatedAt={updatedAt} />}

        <Box>
          <RelatedHouseholds clientId={clientId} />
        </Box>

        <Box px="16">
          <Text variant="cardTitle" mb="24">
            Activity Summary{' '}
            <Text display="inline-block" fontWeight={600} color="neutral.500">
              • {periodLabel}
            </Text>
          </Text>

          <Box>
            <PerformanceSummary isTransactions />
          </Box>
        </Box>

        <Box display="flex" flexDirection="column">
          <AssetAllocationChart tab="left" />
        </Box>

        <Box display="flex" flexDirection="column">
          <AssetAllocationChart tab="right" />
        </Box>
      </MobilePageWrapper>

      <MobileHelperText />
    </>
  );
};
